"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkSherlockList = exports.checkSherlockOpinion = exports.getProfileUpdateBlock = exports.getReplyStatusCount = exports.getEplStatusCount = exports.removeCvSource = exports.updateContactInfo = exports.getContactInfo = exports.searchExperts = exports.getProjectFeedbacks = exports.getOtherServices = exports.getExpertHonorariumHistory = exports.getHonorariumSuggestionFromHistory = exports.getExpertProjects = exports.forgotPassword = exports.addToProjectQueue = exports.checkExpert = exports.typeahead = exports.sendCompliance = exports.deleteAttachment = exports.getAttachments = exports.getInterviewCounts = exports.getInterviewCount = exports.getLastActive = exports.setStaticComplianceDeclined = exports.getUnsubscribeContacts = exports.typeaheadSearch = exports.getContactTypes = exports.unsubscribe = exports.setStaticComplianceSigned = exports.setComplianceSigned = exports.toggleStatus = exports.getPositions = exports.rejectPaymentDetails = exports.approvePaymentDetails = exports.confirmPaymentDetails = exports.savePaymentDetails = exports.getRejectionReasons = exports.getPaymentDetails = exports.remove = exports.updateLinkedinVanityName = exports.updateV2 = exports.update = exports.getManyById = exports.logExpertCall = exports.getEarliestScheduleTime = exports.getOneById = exports.getOne = exports.createBasicProfile = exports.create = void 0;
exports.checkComplianceValidity = exports.expertGuardrailCount = exports.checkExpertSmsAllowed = exports.sendAppDownloadInvitation = exports.updateVerificationStatus = exports.getComplianceLink = exports.signComplianceForExpert = exports.updateLifeScienceFields = exports.getSimilarExperts = exports.getExpertNames = exports.getExpertsForProject = void 0;
var tslib_1 = require("tslib");
var defaultsDeep_1 = tslib_1.__importDefault(require("lodash/defaultsDeep"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
var api_1 = tslib_1.__importStar(require("./api"));
var lib_1 = require("./lib");
var base = '/api/expert';
// Make sure to remove faulty ID values (like null or '') otherwise backend validation will fail
// E.g. {id: null, email: 'john@smith.com'} => {id: undefined, email: 'john@smith.com'}
function cleanUpObject(object) {
    return tslib_1.__assign(tslib_1.__assign({}, object), { id: object.id || undefined });
}
function cleanUpSubIndustry(subIndustryObject) {
    return {
        subindustryId: subIndustryObject.id,
        name: subIndustryObject.name,
    };
}
function isLinkValid(linkObject) {
    return !!linkObject.professionalLinkUrl;
}
function isPhoneValid(phoneObject) {
    return !!phoneObject.phoneNum && !!phoneObject.phoneTypeId;
}
function cleanupData(rawExpertFormData) {
    var expertFormData = (0, lib_1.deepOmit)(rawExpertFormData, ['updatedBy', 'oldNid']);
    expertFormData.expert.newsletter = !!expertFormData.expert.newsletter;
    var subIndustries = expertFormData.expert.subIndustries.map(cleanUpSubIndustry);
    var links = expertFormData.links.filter(isLinkValid).map(cleanUpObject);
    var phones = expertFormData.address.phones.filter(isPhoneValid).map(cleanUpObject);
    var emails = expertFormData.address.emails.map(cleanUpObject);
    var addressData = Object.assign({}, expertFormData.address, {
        phones: phones,
        emails: emails,
    });
    var data = Object.assign({}, expertFormData, {
        email: expertFormData.email || null,
        subIndustries: subIndustries,
        links: links,
        address: addressData,
    });
    data.expert.subIndustries = expertFormData.subIndustries
        ? expertFormData.subIndustries
        : expertFormData.expert.subIndustries;
    data.experiences.forEach(function (e) {
        e.position = e.position.name || e.position;
        e.company = e.company.name || e.company;
    });
    return data;
}
function create(expertFormData) {
    var expertData = cleanupData(expertFormData);
    return api_1.default.post(base, expertData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.create = create;
function createBasicProfile(expertId, profileFormData) {
    return api_1.default.put("/api/expert/".concat(expertId, "/create-basic-profile"), profileFormData);
}
exports.createBasicProfile = createBasicProfile;
function getOne(expertId, eplId) {
    return api_1.default
        .get("/api/expert/".concat(expertId), { params: { eplId: eplId } })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getOne = getOne;
function getOneById(expertId) {
    return api_1.default.get("/api/expert/".concat(expertId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getOneById = getOneById;
function getEarliestScheduleTime(expertId) {
    return api_1.default.get("/api/expert/".concat(expertId, "/earliest-schedule-time")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getEarliestScheduleTime = getEarliestScheduleTime;
function logExpertCall(callLog) {
    return api_1.default.post('/api/expert/log-expert', callLog).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.logExpertCall = logExpertCall;
function getManyById(expertIds) {
    return api_1.default.post("/api/expert/many", { ids: expertIds }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getManyById = getManyById;
function update(expertId, expertFormData, oldExpertData) {
    // _original property is used to compare data changes on the backed and avoid data overwrites
    // if two (or more) different users updated expert's data at the same/similar time
    // Note: This works only on the expert endpoint
    var originalExpertData = { _original: oldExpertData._original };
    var cleansedExpertData = cleanupData(expertFormData);
    var expertData = (0, defaultsDeep_1.default)(Object.assign({ id: expertId }, cleansedExpertData, originalExpertData), oldExpertData);
    return api_1.default.put("".concat(base, "/").concat(expertId), expertData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.update = update;
function updateV2(expertId, expertFormData, oldExpertData) {
    var cleansedExpertData = cleanupData(expertFormData);
    var expertData = (0, defaultsDeep_1.default)(Object.assign({ id: expertId }, cleansedExpertData), oldExpertData);
    return api_1.default.put("/api/v2/expert/".concat(expertId), expertData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateV2 = updateV2;
function updateLinkedinVanityName(expertId, linkedinVanityName) {
    return api_1.default
        .put("".concat(base, "/").concat(expertId, "/linkedin-vanity-name"), { linkedinVanityName: linkedinVanityName })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateLinkedinVanityName = updateLinkedinVanityName;
function remove(expertId) {
    return api_1.default.delete("".concat(base, "/").concat(expertId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.remove = remove;
function getPaymentDetails(expertId) {
    return api_1.default.get("/api/expert-payment-detail/".concat(expertId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getPaymentDetails = getPaymentDetails;
function getRejectionReasons() {
    return api_1.default.get('/api/epd-rejection-reason').then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getRejectionReasons = getRejectionReasons;
function savePaymentDetails(expertId, paymentData) {
    return api_1.default.put("/api/expert-payment-detail/".concat(expertId), paymentData).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.savePaymentDetails = savePaymentDetails;
function confirmPaymentDetails(id) {
    return api_1.default
        .put('/api/expert-payment-detail/' + id + '/confirm')
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.confirmPaymentDetails = confirmPaymentDetails;
function approvePaymentDetails(id) {
    return api_1.default
        .put('/api/expert-payment-detail/' + id + '/approve')
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.approvePaymentDetails = approvePaymentDetails;
function rejectPaymentDetails(payload) {
    var expertId = payload.expertId;
    return api_1.default
        .put('/api/expert-payment-detail/' + expertId + '/unconfirmed', payload)
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.rejectPaymentDetails = rejectPaymentDetails;
function getPositions(expertId, eplId) {
    var data = eplId ? { eplId: eplId } : undefined;
    return api_1.default
        .get("/api/expert/".concat(expertId, "/positions"), { params: tslib_1.__assign({}, data) })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getPositions = getPositions;
function toggleStatus(expertId, payload) {
    return api_1.default.put("/api/expert/".concat(expertId, "/expert-status"), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.toggleStatus = toggleStatus;
function setComplianceSigned(expertId, payload) {
    return api_1.default.put("/api/expert/".concat(expertId, "/set-compliance-signed"), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.setComplianceSigned = setComplianceSigned;
function setStaticComplianceSigned(expertId, referrerID) {
    return api_1.default
        .put("/api/expert/".concat(expertId, "/set-static-compliance-signed"), { referrerID: referrerID })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.setStaticComplianceSigned = setStaticComplianceSigned;
function unsubscribe(payload) {
    var uuid = payload.uuid;
    return api_1.default.post("/api/expert/unsubscribe/".concat(uuid), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.unsubscribe = unsubscribe;
function getContactTypes(uuid) {
    var url = '/api/expert/contact-types';
    if (uuid) {
        url += "/".concat(uuid);
    }
    return api_1.default.get(url, {}).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getContactTypes = getContactTypes;
function typeaheadSearch(name) {
    var url = '/api/expert/typeahead-search?q=' + name;
    return api_1.default.get(url, {}).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.typeaheadSearch = typeaheadSearch;
function getUnsubscribeContacts(uuid) {
    var url = '/api/expert/unsubscribe/contacts';
    if (uuid) {
        url += "/".concat(uuid);
    }
    return api_1.default.get(url, {}).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getUnsubscribeContacts = getUnsubscribeContacts;
function setStaticComplianceDeclined(expertId) {
    return api_1.default.put("/api/expert/".concat(expertId, "/set-static-compliance-declined"), {}).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.setStaticComplianceDeclined = setStaticComplianceDeclined;
function getLastActive(expertId) {
    return api_1.default.get("/api/expert/".concat(expertId, "/last-active")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getLastActive = getLastActive;
function getInterviewCount(expertId) {
    return api_1.default
        .get("/api/expert/interview-count?expertId=".concat(expertId))
        .then(api_1.extractData)
        .then(function (data) { return data[expertId]; })
        .catch(api_1.errorHandler);
}
exports.getInterviewCount = getInterviewCount;
function getInterviewCounts(expertIds) {
    var queryParams = query_string_1.default.stringify({ expertId: expertIds });
    return api_1.default.get("/api/expert/interview-count?".concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getInterviewCounts = getInterviewCounts;
function getAttachments(expertId) {
    return api_1.default.get("/api/expert/".concat(expertId, "/attachments")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getAttachments = getAttachments;
function deleteAttachment(expertId) {
    return api_1.default.delete("/api/expert/attachments/".concat(expertId)).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.deleteAttachment = deleteAttachment;
function sendCompliance(data) {
    return api_1.default.post('/api/expert/compliance/send', data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.sendCompliance = sendCompliance;
function typeahead(query) {
    var encodedQuery = encodeURIComponent(query);
    var limit = 40;
    return api_1.default
        .get("/api/expert/typeahead-search?q=".concat(encodedQuery, "&limit=").concat(limit))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.typeahead = typeahead;
function checkExpert(params) {
    return api_1.default.post("/api/expert/find-duplicates", params).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.checkExpert = checkExpert;
function addToProjectQueue(payload) {
    return api_1.default.post("/api/expert/add-to-project", payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.addToProjectQueue = addToProjectQueue;
function forgotPassword(userEmail) {
    return api_1.default.post('/api/expert/forgot-password', { email: userEmail }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.forgotPassword = forgotPassword;
function getExpertProjects(expertId, limit, offset, eplStatuses, replyStatuses, elasticHighlight, includeScreeningInformation) {
    if (eplStatuses === void 0) { eplStatuses = []; }
    if (replyStatuses === void 0) { replyStatuses = []; }
    if (elasticHighlight === void 0) { elasticHighlight = []; }
    return api_1.default
        .post("/api/expert/projects/".concat(expertId), {
        limit: limit,
        offset: offset,
        eplStatuses: eplStatuses,
        replyStatuses: replyStatuses,
        isFrontend: true,
        elasticHighlight: elasticHighlight,
        includeScreeningInformation: includeScreeningInformation,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getExpertProjects = getExpertProjects;
function getHonorariumSuggestionFromHistory(expertId, isESRProject) {
    return api_1.default
        .post("/api/expert/honorarium-suggestion/".concat(expertId), {
        isESRProject: isESRProject,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getHonorariumSuggestionFromHistory = getHonorariumSuggestionFromHistory;
function getExpertHonorariumHistory(expertId, limit, offset) {
    return api_1.default
        .post("/api/expert/honorarium-history/".concat(expertId), {
        limit: limit,
        offset: offset,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getExpertHonorariumHistory = getExpertHonorariumHistory;
function getOtherServices(expertId, limit, offset) {
    return api_1.default
        .get("/api/expert/".concat(expertId, "/other-services?limit=").concat(limit, "&offset=").concat(offset))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getOtherServices = getOtherServices;
function getProjectFeedbacks(eplId, expertId) {
    return api_1.default
        .get("/api/expert-project-feedback/by-epl?eplId=".concat(eplId, "&expertId=").concat(expertId))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.getProjectFeedbacks = getProjectFeedbacks;
//pass in { index: 'expertvX' } as params to query different expert index(default is defined in search-service env.ES_EXPERT_INDEX_DEFAULT)
//useful when production should query different indexes(feature flag for example)
function searchExperts(data, params) {
    // COMMENT TO FORCE COMPILE
    return api_1.default
        .post("".concat(process.env.REACT_APP_SEARCH_SERVICE_URL, "/expert"), data, { params: params })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.searchExperts = searchExperts;
function getContactInfo(_a) {
    var firstName = _a.firstName, lastName = _a.lastName, companies = _a.companies;
    return api_1.default.post("".concat(base, "/contact-info"), { firstName: firstName, lastName: lastName, companies: companies }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.getContactInfo = getContactInfo;
function updateContactInfo(expertId, data) {
    return api_1.default.put("".concat(base, "/").concat(expertId, "/contact-info"), data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateContactInfo = updateContactInfo;
function removeCvSource(cvSourceId, cvId) {
    return api_1.default.delete("/api/cv-source/".concat(cvSourceId), { data: { cvId: cvId } }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.removeCvSource = removeCvSource;
function getEplStatusCount(expertId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, api_1.default.get("".concat(base, "/projects/").concat(expertId, "/epl-status-count")).then(api_1.extractData).catch(api_1.errorHandler)];
        });
    });
}
exports.getEplStatusCount = getEplStatusCount;
function getReplyStatusCount(expertId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, api_1.default.get("".concat(base, "/projects/").concat(expertId, "/reply-status-count")).then(api_1.extractData).catch(api_1.errorHandler)];
        });
    });
}
exports.getReplyStatusCount = getReplyStatusCount;
function getProfileUpdateBlock(expertId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, api_1.default.get("".concat(base, "/").concat(expertId, "/profile-update-block")).then(api_1.extractData).catch(api_1.errorHandler)];
        });
    });
}
exports.getProfileUpdateBlock = getProfileUpdateBlock;
function checkSherlockOpinion(expertId) {
    return api_1.default.get("".concat(base, "/").concat(expertId, "/sherlock")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.checkSherlockOpinion = checkSherlockOpinion;
function checkSherlockList(experts) {
    return api_1.default.post("".concat(base, "/sherlock-list"), { results: experts }).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.checkSherlockList = checkSherlockList;
function getExpertsForProject(expertIds) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, api_1.default.post("".concat(base, "/for-project"), { expertIds: expertIds }).then(api_1.extractData).catch(api_1.errorHandler)];
        });
    });
}
exports.getExpertsForProject = getExpertsForProject;
function getExpertNames(expertIds) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, api_1.default
                    .get("".concat(base, "/names?ids=").concat(JSON.stringify(expertIds)))
                    .then(api_1.extractData)
                    .catch(api_1.errorHandler)];
        });
    });
}
exports.getExpertNames = getExpertNames;
function getSimilarExperts(expertId, page, perPage, country, city) {
    if (page === void 0) { page = 1; }
    if (perPage === void 0) { perPage = 20; }
    if (country === void 0) { country = ''; }
    if (city === void 0) { city = ''; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var queryParams;
        return tslib_1.__generator(this, function (_a) {
            queryParams = query_string_1.default.stringify({
                page: page,
                limit: perPage,
                country: country,
                city: city,
            }, { skipEmptyString: true });
            return [2 /*return*/, api_1.default.get("".concat(base, "/").concat(expertId, "/similar?").concat(queryParams)).then(api_1.extractData).catch(api_1.errorHandler)];
        });
    });
}
exports.getSimilarExperts = getSimilarExperts;
function updateLifeScienceFields(expertId, data) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, api_1.default.post("".concat(base, "/").concat(expertId, "/life-science"), data).then(api_1.extractData).catch(api_1.errorHandler)];
        });
    });
}
exports.updateLifeScienceFields = updateLifeScienceFields;
function signComplianceForExpert(expertId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, api_1.default.post("".concat(base, "/").concat(expertId, "/compliance")).then(api_1.extractData).catch(api_1.errorHandler)];
        });
    });
}
exports.signComplianceForExpert = signComplianceForExpert;
function getComplianceLink(expertId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/, api_1.default.post("".concat(base, "/compliance/link"), { expertId: expertId }).then(api_1.extractData).catch(api_1.errorHandler)];
        });
    });
}
exports.getComplianceLink = getComplianceLink;
function updateVerificationStatus(expertId, payload) {
    return api_1.default.put("/api/expert/".concat(expertId, "/verification-status"), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.updateVerificationStatus = updateVerificationStatus;
function sendAppDownloadInvitation(payload) {
    return api_1.default.post("".concat(base, "/expert-invite-app-download"), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.sendAppDownloadInvitation = sendAppDownloadInvitation;
function checkExpertSmsAllowed(payload) {
    return api_1.default.post("".concat(base, "/expert-sms-allowed"), payload).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.checkExpertSmsAllowed = checkExpertSmsAllowed;
function expertGuardrailCount(expertId) {
    return api_1.default.get("".concat(base, "/").concat(expertId, "/guardrail")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.expertGuardrailCount = expertGuardrailCount;
function checkComplianceValidity(expertId) {
    return api_1.default.get("".concat(base, "/").concat(expertId, "/check-compliance-validity")).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.checkComplianceValidity = checkComplianceValidity;
var api = {
    addToProjectQueue: addToProjectQueue,
    approvePaymentDetails: approvePaymentDetails,
    checkExpert: checkExpert,
    checkSherlockList: checkSherlockList,
    checkSherlockOpinion: checkSherlockOpinion,
    confirmPaymentDetails: confirmPaymentDetails,
    create: create,
    createBasicProfile: createBasicProfile,
    deleteAttachment: deleteAttachment,
    forgotPassword: forgotPassword,
    getAttachments: getAttachments,
    getComplianceLink: getComplianceLink,
    getContactInfo: getContactInfo,
    getContactTypes: getContactTypes,
    getEplStatusCount: getEplStatusCount,
    getExpertHonorariumHistory: getExpertHonorariumHistory,
    getExpertNames: getExpertNames,
    getExpertProjects: getExpertProjects,
    getExpertsForProject: getExpertsForProject,
    getInterviewCount: getInterviewCount,
    getInterviewCounts: getInterviewCounts,
    getLastActive: getLastActive,
    getManyById: getManyById,
    getOne: getOne,
    getOneById: getOneById,
    getOtherServices: getOtherServices,
    getPaymentDetails: getPaymentDetails,
    getPositions: getPositions,
    getProfileUpdateBlock: getProfileUpdateBlock,
    getProjectFeedbacks: getProjectFeedbacks,
    getRejectionReasons: getRejectionReasons,
    getReplyStatusCount: getReplyStatusCount,
    getSimilarExperts: getSimilarExperts,
    logExpertCall: logExpertCall,
    rejectPaymentDetails: rejectPaymentDetails,
    remove: remove,
    removeCvSource: removeCvSource,
    savePaymentDetails: savePaymentDetails,
    searchExperts: searchExperts,
    sendCompliance: sendCompliance,
    setComplianceSigned: setComplianceSigned,
    setStaticComplianceDeclined: setStaticComplianceDeclined,
    setStaticComplianceSigned: setStaticComplianceSigned,
    signComplianceForExpert: signComplianceForExpert,
    toggleStatus: toggleStatus,
    typeahead: typeahead,
    unsubscribe: unsubscribe,
    update: update,
    updateContactInfo: updateContactInfo,
    updateLinkedinVanityName: updateLinkedinVanityName,
    updateLifeScienceFields: updateLifeScienceFields,
    updateVerificationStatus: updateVerificationStatus,
    sendAppDownloadInvitation: sendAppDownloadInvitation,
    checkExpertSmsAllowed: checkExpertSmsAllowed,
    getEarliestScheduleTime: getEarliestScheduleTime,
    checkComplianceValidity: checkComplianceValidity,
};
exports.default = api;
